import {CLEAR_UPSELL_SETTINGS, FETCH_UPSELL_SETTINGS, REORDER_UPSELL_PRODUCTS} from "../../../actions/types";
import {arrayMove} from "react-sortable-hoc";

const INITIAL_STATE = {

    upsellProducts:[]
};


export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case FETCH_UPSELL_SETTINGS:
            return action.payload.data;
        case REORDER_UPSELL_PRODUCTS:
            state = {
                ...state,
                upsellProducts: arrayMove(state.upsellProducts, action.payload.oldIndex, action.payload.newIndex)
            };
            state.upsellProducts.map((upsell, index) => {
                upsell.priority = index + 1;
            });
            return state;
        case CLEAR_UPSELL_SETTINGS:
            return INITIAL_STATE;
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/restaurants/upsell/UpsellSettingsReducer.js